import config from '../../config';
import utils from '@/utils/util';
import queryParams from '@/services/pageQuery.service';
import { USER_TYPE } from '../socketIO/const';
import speakerConfig from '@/services/vrShow/speaker.config';
const { appCurrentVersion, icsAppCurrentVersion, icsSetWebViewVersion } =
  speakerConfig;

function isVrShowComponent() {
  const userType = getUserType();
  return [USER_TYPE.USER, USER_TYPE.SALES].includes(userType);
}
function getUserType() {
  const realtimeanswer = queryParams.realtimeanswer;
  const userType = queryParams.userType;
  const isICSApp = utils.isICSApp() || userType === USER_TYPE.SALES;
  if (isICSApp && realtimeanswer === 1) {
    return USER_TYPE.SALES;
  }
  if (showVrRtcInAutoApp()) {
    return USER_TYPE.USER;
  }
  return USER_TYPE.NONE;
}
export function isWorkTime() {
  const currentHour = new Date().getHours();
  // 是否在工作时间
  const isWorkingTime = currentHour >= 9 && currentHour < 18;
  return isWorkingTime;
}
function showVrRtcInAutoApp() {
  const userType = queryParams.userType;
  if (userType === USER_TYPE.USER) {
    return true;
  }
  const isApp = utils.browser.isApp;
  const isMobile = utils.browser.isMobile;
  const v = config.appVersionNum;
  const autoHomeApp = isApp && utils.compareAppVersionNum(v);
  const isMobileAndUnApp = !isApp && isMobile;
  return autoHomeApp || isMobileAndUnApp;
}
function isHeigherAppVersionNum() {
  return utils.compareAppVersionNum(appCurrentVersion);
}
function isHeigherIcsAppVersionNum(currentVersion) {
  return utils.compareIcsAppVersionNum(icsAppCurrentVersion, currentVersion);
}
function isHeigherIcsSetWebViewAppVersionNum(currentVersion) {
  console.log('icsSetWebViewVersion :', icsSetWebViewVersion);
  return utils.compareIcsAppVersionNum(icsSetWebViewVersion, currentVersion);
}
export {
  isVrShowComponent,
  showVrRtcInAutoApp,
  getUserType,
  isHeigherAppVersionNum,
  isHeigherIcsAppVersionNum,
  isHeigherIcsSetWebViewAppVersionNum,
};
